export abstract class GPUAPIObject<T> {
	protected abstract createFunction(): T | null
	protected abstract deleteFunction(): void
	abstract bind(...args: any): () => void // must return `unbind` function
	gl: WebGL2RenderingContext
	obj: T | null
	constructor(gl: WebGL2RenderingContext) {
		this.gl = gl
		this.obj = this.createFunction()
		this.checkValidity("creation failed")
		this.obj = this.checkValidity()
	}
	delete() {
		this.checkValidity("already deleted")
		this.deleteFunction()
		this.obj = null
	}
	protected checkValidity(msg?: string): T {
		if (this.obj == null) { throw msg }
		return this.obj
	}
	use(callback: (obj: T) => void = () => { }) {
		this.obj = this.checkValidity()
		let unbind = this.bind()
		callback(this.obj)
		unbind()
	}
}
